module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-1-poster.965271b2.jpg";